import { CallRecordKey } from 'flow/types/EntityKeys';
import { useAppSelector } from 'flow/hooks/useRedux';
import {
    selectExtendedTranscriptionIsPending,
    selectExtendedTranscriptionIsPersonal,
    selectExtendedTranscriptionKey,
} from 'flow/selectors/call-records-selectors';
import { useModal } from 'flow/contexts/ModalProvider';
import useAppContext from 'flow/hooks/useAppContext';
import Icon from 'flow/components/ui-components/Icon';
import MenuItem from 'flow/components/ui-components/MenuItem';
import { Tooltip } from 'flow/components/ui-components/Tooltip';

interface Props {
    callRecordKey: CallRecordKey;
}

const MenuItemDeleteExtendedTranscription = ({ callRecordKey }: Props) => {
    const { i18next } = useAppContext();
    const { openModal } = useModal();

    const isPersonalTranscription = useAppSelector((state) =>
        selectExtendedTranscriptionIsPersonal(state, callRecordKey),
    );
    const isPending = useAppSelector((state) =>
        selectExtendedTranscriptionIsPending(state, callRecordKey),
    );
    const extendedTranscriptionKey = useAppSelector((state) =>
        selectExtendedTranscriptionKey(state, callRecordKey),
    );

    if (!isPersonalTranscription) return null;

    const onClickDelete = () => {
        openModal('deleteTranscription', {
            extendedTranscriptionKey,
            callRecordKey,
            isPersonal: isPersonalTranscription,
        });
    };

    const menuItem = (
        <MenuItem
            onClick={onClickDelete}
            disabled={isPending}
            className={isPending ? 'text-red opacity-50' : undefined}
        >
            <div className="text-red flex items-center gap-x-2">
                <Icon iconKey="delete" />
                {i18next.t('call.transcription.delete')}
            </div>
        </MenuItem>
    );

    if (!isPending) return menuItem;

    return (
        <Tooltip
            label={i18next.t('call.transcription.delete.disabled.pending')}
        >
            {menuItem}
        </Tooltip>
    );
};

export default MenuItemDeleteExtendedTranscription;
